import { apiClient } from "@/services/apiServices";

export const getHashAndThumbnailsForVideos = async ({
  videoUrls,
}: {
  videoUrls: string[];
}) => {
  try {
    const payload = {
      videoUrls: videoUrls,
    };
    const response = await apiClient.post(
      "/upload/get-thumbnail-and-hash-for-videos",
      payload,
    );
    return response?.data?.data ?? [];
  } catch (err) {
    console.log(err);
    // The video is already in S3. Preview failure must not discard its URL.
    return [];
  }
};
